import { useQuery } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useMainQueryKey } from './useMainQueryKey'

const document = graphql(`
  query RestorePage_Main($key: String) {
    restoringParams(key: $key) {
      value
    }
  }
`)

export const useMainQuery = () => {
  const graphQLRequest = useGraphQLRequest()
  const queryKey = useMainQueryKey()
  const [_, variables] = queryKey

  return useQuery({
    queryFn: () => graphQLRequest({ document, variables }),
    queryKey,
  })
}
